import React from "react";
import styles from "./Loader.module.scss";
export var Loader = function Loader() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "128px",
    height: "128px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: styles.loader,
    style: {
      position: "absolute"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "7.13938",
    fill: "none",
    strokeWidth: "6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: "1",
    keySplines: "0 0.2 0.8 1",
    begin: "-0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1",
    keySplines: "0.2 0 0.8 1",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "29.0007",
    fill: "none",
    strokeWidth: "6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    values: "0;40",
    keyTimes: "0;1",
    dur: "1",
    keySplines: "0 0.2 0.8 1",
    begin: "0s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    calcMode: "spline",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1",
    keySplines: "0.2 0 0.8 1",
    begin: "0s",
    repeatCount: "indefinite"
  })));
};
export default Loader;